import React from 'react';

function NotFound() {
  return (
    <>
       <style jsx>{`
       @media screen and (max-width: 768px) {
        .flex {
          max-width: 100%;
        }
        .text-center h1{
          font-size: 2rem;
        }
      }
      `}</style>
    <div className="flex items-center justify-center h-screen bg-gray-800">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-gray-950 mb-4">Data - Not Found</h1>
        <p className="text-lg text-gray-600 mb-8">Sorry, the content you are looking for does not exist.</p>
        {/* <img src="/path/to/your/image.jpg" alt="Page Not Found" className="w-64 mx-auto mb-4" /> */}
        <a href="/" className="text-blue-600 hover:underline">Go back to home</a>
      </div>
    </div>
    </>
  );
}

export default NotFound;
